import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import App from './containers/App'

// Load all routes
import { routes as ResetPasswordRoutes } from './containers/ResetPassword'
import { routes as UnsubscribeRoutes } from './containers/Unsubscribe'
import { routes as FlagInappropriateRoutes } from './containers/FlagInappropriate'
import { routes as MarketingOptInRoutes } from './containers/MarketingOptIn'

export default () => (
  <Router>
    <Switch>
      <Route exact path='/' component={App} />
      {UnsubscribeRoutes}
      {ResetPasswordRoutes}
      {FlagInappropriateRoutes}
      {MarketingOptInRoutes}
    </Switch>
  </Router>
)



// WEBPACK FOOTER //
// ./src/Routes.js